export default "__VITE_ASSET__9fu_nG8o__";